import { env } from 'config/env';
import { TranslationType } from 'generated/graphql';
import { NotSelectedTranslationType } from 'stores/interfaces/CommonQueryState';

export const filterAllowedTranslationTypes = (
  translationType: TranslationType | NotSelectedTranslationType
): boolean => {
  if (translationType === TranslationType.CORPORATE_CONTENT) {
    return env?.REACT_APP_ALLOW_CORPORATE_CONTENT_QUERY_CREATION === 'true';
  }
  if (translationType === TranslationType.ABAP) {
    return env?.REACT_APP_ALLOW_ABAP_QUERY_CREATION === 'true';
  }
  if (translationType === TranslationType.NOTES) {
    return env?.REACT_APP_ALLOW_NOTES_QUERY_CREATION === 'true';
  }
  if (translationType === TranslationType.MARKETING) {
    return env?.REACT_APP_ALLOW_MARKETING_QUERY_CREATION === 'true';
  }
  return true;
};
